export const ONBOARDING_ENDPOINTS = {
  DETAIL: (companyId) => `/onboard/${companyId}`,
  SAVE: (project, companyId) => `/onboard/${project}/${companyId}`,
  UPLOAD_BATCH: (companyId) => `/files/upload/batch/${companyId}`,
  MEETING_REQUEST: "/users/meeting-request",
  SEND_NOTIFICATION: "/notification",
  NXMAP_CODE: "/members/get_code/nxmap",
};
